import { render } from "./App.vue?vue&type=template&id=f348271a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f348271a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f348271a', __exports__)) {
    console.log('reload')
    api.reload('f348271a', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=f348271a", () => {
    console.log('re-render')
    api.rerender('f348271a', render)
  })

}


export default __exports__